import { PaginationProps, SortDirection } from '@touche-lts/panel-ui/dist'
import {
  UsersInStoreTableSearchProps,
  UsersInStoreTableSortProps
} from './users-in-store-table-store.types'

export const initialUsersInStoreTablePaginationProps: PaginationProps<UsersInStoreTableSortProps> = {
  page: 0,
  size: window.innerWidth >= 1920 ? 10 : 6,
  sortDirection: SortDirection.DESC,
  sortProp: UsersInStoreTableSortProps.NAME,
  totalElements: 0,
  totalPages: 0
}

export const initialUsersInStoreTableSearchProps: UsersInStoreTableSearchProps = {
  name: '',
  role: '' as any,
  addedOnPeriod: null
}

export const usersInStoreTableNeedTimeoutProps: Array<keyof UsersInStoreTableSearchProps> = [
  'name'
]
